import { useEffect, useState } from 'react';

function usePrevious<T>(value?: T) {
  const [state, setState] = useState<{ current?: T; previous?: T }>({
    current: value,
    previous: undefined,
  });

  useEffect(() => setState(prev => ({ current: value, previous: prev.current })), [value]);
  return state.previous;
}

export default usePrevious;
